"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/es.object.get-own-property-descriptor.js");
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Tab;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.set.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
require("core-js/modules/web.dom-collections.for-each.js");
require("core-js/modules/es.regexp.to-string.js");
var _react = _interopRequireWildcard(require("react"));
var _isChildOfType = require("../_utils/isChildOfType");
var _TabItem = _interopRequireDefault(require("./TabItem"));
var _usePrefixCls = require("../_utils/hooks/usePrefixCls");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
/* eslint-disable @typescript-eslint/naming-convention */

function NavItem(_ref) {
  var active = _ref.active,
    id = _ref.id,
    label = _ref.label,
    _ref$onActive = _ref.onActive,
    onActive = _ref$onActive === void 0 ? function () {
      return null;
    } : _ref$onActive;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('tab');
  return /*#__PURE__*/_react.default.createElement("li", {
    onClick: function onClick(evt) {
      return onActive(id, evt);
    },
    className: "".concat(prefixCls, "-simple ").concat(active ? 'active' : ''),
    key: id
  }, /*#__PURE__*/_react.default.createElement("span", {
    className: "".concat(prefixCls, "-text")
  }, label));
}
function Tab(_ref2) {
  var _ref2$tabs = _ref2.tabs,
    tabs = _ref2$tabs === void 0 ? [] : _ref2$tabs,
    _ref2$destroyInactive = _ref2.destroyInactiveTabPanel,
    destroyInactiveTabPanel = _ref2$destroyInactive === void 0 ? true : _ref2$destroyInactive,
    activeId = _ref2.activeId,
    onActive = _ref2.onActive,
    defaultActiveId = _ref2.defaultActiveId,
    children = _ref2.children,
    type = _ref2.type;
  var prefixCls = (0, _usePrefixCls.usePrefixCls)('tab');

  // 如果都没有定义，获取第一个没被禁用的选项卡 id
  if (typeof activeId === 'undefined' && typeof defaultActiveId === 'undefined') {
    var firstAvaliable = tabs.find(function (x) {
      return !x.disabled;
    });
    // eslint-disable-next-line no-param-reassign
    defaultActiveId = firstAvaliable ? firstAvaliable.id : null;
  }

  // 注意 useState 是个 Hooks，不能写在 if 里面
  var _useState = (0, _react.useState)(defaultActiveId),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    internalActiveId = _useState2[0],
    setInternalActiveId = _useState2[1];

  // 非受控模式下，使用内部状态
  if (typeof activeId === 'undefined') {
    // eslint-disable-next-line no-param-reassign
    activeId = internalActiveId;
    // eslint-disable-next-line no-param-reassign
    onActive = function (onActive) {
      return function (tab, evt) {
        setInternalActiveId(tab.id);
        console.log('onActive', tab);
        if (typeof onActive === 'function') {
          onActive(tab, evt);
        }
      };
    }(onActive);
  }
  var panelRenderedSetRef = (0, _react.useRef)(new Set());
  function TabNavs(_ref3) {
    var type = _ref3.type,
      _ref3$onActive = _ref3.onActive,
      onActive = _ref3$onActive === void 0 ? function () {
        return null;
      } : _ref3$onActive;
    var panelRenderedSet = panelRenderedSetRef.current;
    var panelNav = [];
    _react.default.Children.forEach(children, function (child) {
      if ((0, _isChildOfType.isChildOfType)(child, _TabItem.default)) {
        var props = child.props,
          key = child.key;
        var label = props.label,
          id = props.id,
          icon = props.icon;
        var active = activeId === props.id;
        if (active && !panelRenderedSet.has(activeId)) {
          panelRenderedSet.add(activeId);
        }
        panelNav.push( /*#__PURE__*/_react.default.createElement(NavItem, {
          id: id,
          label: label,
          active: active,
          onActive: onActive,
          key: key || id
        }));
      }
    });
    var customeNav = /*#__PURE__*/_react.default.createElement("div", {
      className: "".concat(prefixCls, "-parent")
    }, panelNav);
    return customeNav;
  }
  function getTabPanels() {
    var panelRenderedSet = panelRenderedSetRef.current;
    var panelChildren = [];
    var disabledStyle = {
      height: '0px',
      width: '0px',
      overflow: 'hidden',
      opacity: 0,
      padding: '0px',
      margin: '0px',
      pointerEvents: 'none',
      display: 'block',
      transform: 'translate3d(0px, 10px, 0px)'
    };
    _react.default.Children.forEach(children, function (child, index) {
      if ((0, _isChildOfType.isChildOfType)(child, _TabItem.default)) {
        var props = child.props,
          key = child.key;
        var id = props.id;
        var active = activeId === props.id;
        if (active && !panelRenderedSet.has(activeId)) {
          panelRenderedSet.add(activeId);
        }
        if (destroyInactiveTabPanel && active || !destroyInactiveTabPanel && panelRenderedSet.has(props.id)) {
          panelChildren.push( /*#__PURE__*/_react.default.cloneElement(child, {
            key: key || id,
            style: active ? {
              display: 'block'
            } : disabledStyle
          }));
        } else {
          panelChildren.push( /*#__PURE__*/_react.default.createElement(_TabItem.default, {
            id: id,
            key: key || id,
            style: disabledStyle
          }));
        }
      } else if ( /*#__PURE__*/_react.default.isValidElement(child)) {
        panelChildren.push( /*#__PURE__*/_react.default.cloneElement(child, {
          key: index.toString()
        }));
      } else {
        panelChildren.push( /*#__PURE__*/_react.default.createElement("div", {
          key: index.toString()
        }, child));
      }
    });
    return panelChildren;
  }
  var handleChange = function handleChange(id, e) {
    setInternalActiveId(id);
    if (onActive) {
      onActive(id, e);
    }
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(prefixCls, "-tabs")
  }, /*#__PURE__*/_react.default.createElement(TabNavs, {
    activeId: activeId,
    onActive: handleChange,
    type: type
  }), getTabPanels()));
}